<template>
  <DashboardMobile v-if="isMobile()" />
  <DashboardDesktop v-else />
</template>

<script>
import {mapActions, mapMutations, mapState} from "vuex";

import { BUYER } from "@/constants/Buyer";
import PlatformsMixins from "@/mixins/PlatformsMixins";

import DashboardMobile from "./DashboardMobile";
import DashboardDesktop from "./DashboardDesktop";

export default {
  name: "DashboardBuyer",
  components: {
    DashboardMobile,
    DashboardDesktop,
  },
  mixins: [PlatformsMixins],
  data() {
    return {
      loading: true,
      payload: [],
    };
  },
  computed: {
    ...mapState({
      loading: (state) => state.buyer.dashboardFilter.loading,
    }),
  },
  methods: {
    ...mapMutations("buyer", [
      "setTitlePage",
      "setTitleSectionPage",
      "setResultCountsLeftMenu",
    ]),
    ...mapActions("buyer", [
      "getDashboardCounts",
    ]),
    ...mapActions("wallet", ["getBalance"]),
  },
  async mounted() {
    this.setTitlePage(BUYER.TITLE_DASHBOARD);
    this.setTitleSectionPage(BUYER.TITLE_SECTION_DEFAULT);
    await Promise.all([
      this.getDashboardCounts(),
      this.getBalance()
    ])
    this.$emitter.on('refreshEvent', (from) => {
      if (from === 'RefreshBalance') {
        this.getBalance();
      }
    });
  },
};
</script>

<style scoped>
#dashboard {
  flex: 78;
  padding: 1.5em;
  justify-content: center;
  padding-right: 25px;
  overflow: hidden;
}

.dashboard-header h1 {
  color: #373737;
  font-family: "Lexend Deca";
  font-size: 26px;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
}
</style>
